const SYM = '🧀'

/** Dollars → whole Cheddar: fmt(10.00) = "🧀1,000" */
export function fmt(dollars: number): string {
  return `${SYM}${Math.round(dollars * 100).toLocaleString('en-US')}`
}

/** Compact volume in Cheddar: fmtCompact(1500) = "🧀150K" */
export function fmtCompact(dollars: number): string {
  const c = dollars * 100
  if (c >= 1_000_000) return `${SYM}${(c / 1_000_000).toFixed(1)}M`
  if (c >= 1_000) return `${SYM}${(c / 1_000).toFixed(1)}K`
  return `${SYM}${Math.round(c).toLocaleString('en-US')}`
}

/** Per-share price (prob 0–1 → whole Cheddar 0–100): fmtPrice(0.5) = "🧀50" */
export function fmtPrice(prob: number): string {
  return `${SYM}${Math.round(prob * 100)}`
}

/** Probability as a percentage string: fmtProbability(0.72) = "72%" */
export function fmtProbability(prob: number): string {
  return `${Math.round(prob * 100)}%`
}
